var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUscTransmitting = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 49 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "7B3782A0-E993-4CA0-A0D8-7C11297AE120")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.521763158 0.672710526 2.89018421 0.672710526 2.89018421 3.94736842 0.521763158 3.94736842"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.566842105 0.292894737 2.93526316 0.292894737 2.93526316 3.56739474 0.566842105 3.56739474"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Events",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Event-Groups",
    transform: "translate(-1097.000000, -434.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTN-/-28-/-USC-/-Connected-Copy-3",
    transform: "translate(1097.000000, 434.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(29.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.835,2.616 C1.13763158,3.62494737 -5.05209909e-13,5.47784211 -5.05209909e-13,7.59521053 C-5.05209909e-13,10.7925789 2.59184211,13.3844211 5.78921053,13.3844211",
    id: "Stroke-1",
    stroke: "#FDAD01",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(4.737158, 11.052632)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FDAD01",
    mask: "url(#mask-2)",
    points: "0.521763158 3.94744737 2.89018421 2.31007895 0.521763158 0.672710526"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.51747368,12.6771316 C10.2148421,11.6681842 11.3516842,9.81528947 11.3516842,7.69713158 C11.3516842,4.50055263 8.76063158,1.90871053 5.56326316,1.90871053",
    id: "Stroke-6",
    stroke: "#FDAD01",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(3.158211, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FDAD01",
    mask: "url(#mask-4)",
    points: "2.93526316 0.292657895 0.566842105 1.93002632 2.93526316 3.56739474"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 5.000000)",
    fill: "#383E41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7996891,3.59989484 L12.5996358,3.59989484 L12.5996358,0 L8.99974245,0 L8.99974245,1.79994742 L10.7996891,1.79994742 L10.7996891,1.79994742 L10.7996891,3.59989484 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5996312,11.6996574 L12.5996312,5.39984168 L10.7996839,5.39984168 L10.7996839,11.6996574 C10.7996839,14.184866 8.78502432,16.1995258 6.29981558,16.1995258 C3.81460685,16.1995258 1.79994731,14.184866 1.79994731,11.6996574 L1.79994731,1.79994723 L7.19978924,1.79994723 L7.19978924,0 L0,0 L0,11.6996574 C0,15.1792403 2.8207598,18 6.30034292,18 C9.77992605,18 12.6006858,15.1792403 12.6006858,11.6996574",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48,0.5 L48.5,27 L1,27.5 L0.5,1 L48,0.5 Z",
    id: "Rectangle",
    stroke: "#E1E1E1"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUscTransmitting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/USCTransmitting.f1ffe481.svg";
export { ForwardRef as ReactComponent };